import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

const cache: Map<string, HttpResponse<any>> = new Map();

@Injectable({ providedIn: 'root' })
export class SfCacheInterceptor implements HttpInterceptor {
  private cacheTimeInMinutes = 5;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.method === 'POST' ||
      req.method === 'PATCH' ||
      req.method === 'PUT'
    ) {
      const apiName = req.url
        .slice(req.url.indexOf('/api/') + 5)
        .substring(0, req.url.indexOf('/') - 1);
      const keys = Array.from(cache.keys()).filter((key) =>
        key.includes('/' + apiName)
      );
      keys.forEach((key) => cache.delete(key));
    }
    if (req.method === 'DELETE') {
      cache.clear();
    }
    if (req.method !== 'GET') {
      return next.handle(req);
    }
    if (req.headers.get('reset')) {
      cache.delete(req.urlWithParams);
    }
    const cachedResponse: HttpResponse<any> = cache.get(req.urlWithParams);
    if (cachedResponse) {
      return of(cachedResponse.clone());
    } else {
      return next.handle(req).pipe(
        tap((stateEvent) => {
          if (stateEvent instanceof HttpResponse) {
            cache.set(req.urlWithParams, stateEvent.clone());
          }
          setTimeout(() => {
            cache.delete(req.urlWithParams);
          }, 1000 * 60 * this.cacheTimeInMinutes);
        })
      );
    }
  }

  public clearCache() {
    cache.clear();
  }
}
